type MaybeCompanyId = string | number | null | undefined;
type MaybeValue = string | number | null | undefined;

export function normalizeCompanyId(companyId: MaybeCompanyId): string {
	const normalized = String(companyId ?? '1').trim();
	return normalized || '1';
}

export function isMainCompany(companyId: MaybeCompanyId): boolean {
	return normalizeCompanyId(companyId) === '1';
}

export function buildCategoryPath(companyId: MaybeCompanyId, productnature?: MaybeValue): string {
	const nature = productnature == null ? '' : String(productnature).trim();
	const base = isMainCompany(companyId) ? '/c' : `/${normalizeCompanyId(companyId)}/c`;
	return nature ? `${base}/${nature}` : base;
}

export function buildCategoryDetailPath(companyId: MaybeCompanyId, categoryId?: MaybeValue): string {
	const normalizedCategoryId = categoryId == null ? '' : String(categoryId).trim();
	if (!normalizedCategoryId) {
		return buildCategoryPath(companyId);
	}
	return isMainCompany(companyId) ? `/c-${normalizedCategoryId}` : `/${normalizeCompanyId(companyId)}/c-${normalizedCategoryId}`;
}

export function buildCategorySearchPath(companyId: MaybeCompanyId): string {
	return isMainCompany(companyId) ? '/category/search' : `/${normalizeCompanyId(companyId)}/search`;
}
